import {
    BackgroundImage,
    FullWidthBackground,
    Grid,
    Theme,
    getThemedValue,
} from '@gravity-ui/page-constructor';

import {ClassNameProps, HeaderBlockProps} from '../../models/common';
import {block} from '../../utils/cn';

import {Controls, ControlsProps} from './components/Controls/Controls';

import './FeedHeader.scss';

const b = block('feed-header');

type HeaderProps = Pick<HeaderBlockProps, 'background' | 'offset' | 'theme' | 'verticalOffset'>;

type FeedHeaderProps = HeaderProps & ControlsProps;

type FeedHeaderContainerProps = FeedHeaderProps & ClassNameProps;

export const FeedHeader = ({
    filters,
    handleLoadData,
    offset = 'default',
    background,
    theme = 'light',
    verticalOffset = 'l',
    className,
    queryParams,
    title,
    resetTitleMargin,
}: FeedHeaderContainerProps) => {
    const backgroundThemed = background && getThemedValue(background, theme as Theme);

    return (
        <header className={b('header', {['has-background']: Boolean(background)}, className)}>
            {backgroundThemed?.color ? (
                <FullWidthBackground
                    style={{backgroundColor: backgroundThemed?.color}}
                    theme="rounded"
                />
            ) : null}
            <Grid className={b('content', {offset, theme, 'vertical-offset': verticalOffset})}>
                {backgroundThemed ? (
                    <BackgroundImage
                        src={backgroundThemed?.url}
                        className={b('background')}
                        imageClassName={b('background-img')}
                        style={{
                            backgroundColor: backgroundThemed.fullWidth
                                ? ''
                                : backgroundThemed?.color,
                        }}
                        disableCompress={backgroundThemed?.disableCompress}
                    />
                ) : null}
                <Controls
                    title={title}
                    filters={filters}
                    handleLoadData={handleLoadData}
                    queryParams={queryParams}
                    resetTitleMargin={resetTitleMargin}
                />
            </Grid>
        </header>
    );
};
